import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent {
isLoading:Subject<boolean> = this.loaderService.isLoading
constructor(private loaderService: LoaderService){

}
}
